import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import Avatar from '@components/avatar';
import { formatTime } from '@utils/timeUtils';
import { withRouter } from 'react-router-dom';
import { BaseComponent } from '@components/Base/h5/BaseComponent';
import type { BaseRouteComponentProps } from '../../../types/base';
import { Image } from 'antd';
import InfiniteScrollList from '@components/InfiniteScrollList';
import updateImageListSrc from "@utils/update-image-list-src";
import parse from 'html-react-parser';
import { replaceEmojiCodes } from '@utils/emoji';

interface H5UserPostListProps extends BaseRouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    data: any;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    likeClick?: Function;
    goDetails?: Function;
    goTopicDetails?: Function;
    goUser?: Function;
    recommendUserList?: any // 推荐关注用户列表
    showRecommendUserList?: any // 是否显示推荐关注用户
    createFollowUser?: any  // 关注用户事件
    followDelete?: any  // 取消关注用户事件
    searchKeyword?: any // 需要高亮的关键字
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
}

@inject('app', 'site', 'user')
@observer
class H5UserPostList extends BaseComponent<H5UserPostListProps> {
    private replaceEmojiInContent = (content?: string) => replaceEmojiCodes(content || '', this.props.site?.emojiList || []);

    // 渲染单个列表项
    renderThreadItem = (item: any, index: number) => {
        const { goDetails, goUser } = this.props;
        // console.log(showRecommendUserList, '是否显示推荐关注列表', recommendUserList)
        let options = {};
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
            },
            ...options
        };
        return (
            <React.Fragment key={item.id || item._id || index}>
                <div
                    className={styles.postItem}
                    key={item.id || item._id}
                >
                    <div className={styles.postUserBox}>
                        <div className={styles.postUserLeft}>
                            <Avatar
                                avatarUrl={item.user?.avatar}
                                userCode={item.user?.code}
                                size={60}
                                titleMark={item.user?.titleMark}
                                officialSize={24}
                            ></Avatar>
                            <div className={styles.userDetail}>
                                <div
                                    className={styles.userNameBox}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        goUser && goUser(item.user);
                                    }}
                                >
                                    <div className={styles.userName}>
                                        {item.user?.nickname || '普通用户'}
                                    </div>
                                    {item.user?.titleName && (
                                        <div className={styles.titleName}>
                                            {item.user?.titleName}
                                        </div>
                                    )}
                                </div>
                                {/* 评论内容 */}
                                <div className={styles.plainText} onClick={() => goDetails && goDetails(item, true)} style={{marginBottom: item?.images?.length > 0 ? '16px' : ''}}>{parse(this.replaceEmojiInContent(item.content), parserOptions)}</div>
                                {/* 评论图片 */}
                                {item?.images?.length > 0 && (
                                    <div className={styles.postImgListBox}>
                                        {item?.images.map((img: any, imgIndex: number) => (
                                            <Image key={img.id || imgIndex} width={110} height={110} style={{borderRadius: '4px', objectFit: 'cover'}} src={updateImageListSrc(img.url, 9)} alt="basic" preview={{ mask: '预览' }} />
                                        ))}
                                    </div>
                                )}
                                <div className={styles.postInfo}>
                                    <div>{formatTime(item.createdAt, false)}</div>
                                    {item.source && <>
                                        <div className={styles.gap}></div>
                                        <div>{item.source}</div>
                                    </>}
                                    {item.ipRegion && <>
                                        <div className={styles.gap}></div>
                                        <div>{item.ipRegion}</div>
                                    </>}
                                </div> 
                                {/* 帖子详情 */}
                                <div className={styles.postThreadText} onClick={() => goDetails && goDetails(item)}> {item.postable?.title || item.postable?.summary}</div>
                                  
                            </div>
                        </div>
                    </div>


                </div>
            </React.Fragment>
        );
    };

    renderContent() {
        const { data, loading = false, hasMore = true, emptyText, emptyIcon, emptyBoxStyle, onLoadMore } = this.props;

        if (!Array.isArray(data)) return null;

        return (
            <div className={styles.threadListBox}>
                <InfiniteScrollList
                    variant="h5"
                    data={data}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore || (() => { })}
                    renderItem={(item, index) => this.renderThreadItem(item, index)}
                    threshold={100}
                    emptyText={emptyText || '这里是空的'}
                    emptyIcon={emptyIcon}
                    emptyBoxStyle={emptyBoxStyle}
                    loadingText="加载中..."
                    noMoreText="没有更多帖子了"
                />
            </div>
        );
    }
}

export default withRouter(H5UserPostList);